// Rails :back link uses previous url, which does not save form states
window.Reverb = window.Reverb || {};

Reverb.LinkToBack = (function () {
  const backLinkSelector = '[data-link-to-back]';

  function bindLinkClicks() {
    $(document).on('click', backLinkSelector, (e) => {
      e.preventDefault();
      history.back();
    });
  }

  return {
    bindLinkClicks,
  };
}());

$(Reverb.LinkToBack.bindLinkClicks);
